<template>
<v-container>
  <h2 class="title">{{ $t(action+'.title')}}</h2>
  <div v-if="step == 1">
    <v-alert type="warning" v-model="alert2">
   {{ alertText2 }}
    </v-alert>
    <p>{{ $t('signup.textSignup')}}</p>
    <p><v-btn @click="manualAuth()" block>{{ $t('signup.withEmail') }}</v-btn></p>
    <p><v-btn @click="step2('fb')" :loading="loadingAuth.fb" block dark color="#4267B2"><v-icon class="mr-2">mdi-facebook</v-icon>&nbsp; {{ $t('signup.withFacebook') }}</v-btn></p>
    <p><v-btn @click="step2('google')" :loading="loadingAuth.google"  block dark color="#4285F4"><v-icon class="mr-2">mdi-google</v-icon>&nbsp; {{ $t('signup.withGoogle') }}</v-btn></p>
  </div>
  <div v-else>
  <v-alert type="warning" v-model="alert">
 {{ alertText }}
  </v-alert>
    <v-form class="mt-3" @submit.prevent="actionMethod()">
      <p>{{ $t('signup.mandatoriesFields') }}</p>
      <v-text-field
      v-if="action == 'signup'"
      v-model="form.nickname"
      :label="$t('signup.fields.nickname')"
      required
      :rules="[rules.required]"
      outlined
       ></v-text-field>
        <v-text-field
        v-model="form.email"
        :label="$t('signup.fields.mail')"
        required
        :rules="[rules.required, rules.email]"
        outlined
         ></v-text-field>
         <v-text-field
        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show2 ? 'text' : 'password'"
        name="input-10-2"
        v-model="form.password"
        :label="$t('signup.fields.password')"
        outlined
        required
        class="input-group--focused"
        @click:append="show2 = !show2"
      ></v-text-field>
      <v-checkbox v-if="action == 'signup'" v-model="cgu" :label="textCGU()"></v-checkbox>

<v-btn :disabled="disabled" block type="submit" :loading="loading" :dark="!disabled" color="teal darken-2">{{ $t(action+'.actionName') }}</v-btn>
  </v-form>
</div>
</v-container>

</template>
<script>
import firebase from '@firebase/app';
import '@firebase/auth';
//import '@firebase/auth';

export default {
  props: ['action', 'redirect'],
  data () {
    return {
      loadingAuth: {fb: false, google: false},
      rules: {
     required: value => !!value || this.$t('signup.validation.required'),
     email: value => {
           const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
           return pattern.test(value) || this.$t('signup.validation.invalidEmail')
         }
       },
       step: 1,
       submitMethod: null,
       cgu: false,
      alert: false,
      alertText: '',
      alert2: false,
      alertText2: '',
      loading: false,
      show2: false,
      form: {email: '', password: '', nickname: ''}
    }
  },
  computed: {
    disabled() {
      return (this.action=='signup' && !this.cgu && !this.formOK) || !this.formOK;
    },
    formOK() {
      if (this.action == 'signup') {
        return this.cgu && this.form.nickname.length > 0 && this.form.email.length > 0 && this.form.password.length;
      } else {
        return  this.form.email.length > 0 && this.form.password.length;

      }

    }
  },
  mounted() {
    if (this.action == 'signin') {
      this.actionMethod = this.signin;
    } else {
      this.actionMethod = this.signup;
    }
  },
  methods: {
    signin() {
      this.loading = true;
        const self = this;
      firebase.auth().signInWithEmailAndPassword(this.form.email, this.form.password).then(()=>{
        self.loading  = false;
        if (self.redirect) {
          self.$router.push(self.redirect);
        } else {
          self.$router.push({name:'Home'});
        }
      }).catch(function(e) {
        self.alertText = self.$t('firebaseAuthError.'+e.code)
        self.alert = true;
          self.loading  = false;
        });
    },
    wording() {
      return this.$t(this.action+'.action');
    },
    manualAuth() {
      this.step = 2;
    },
    step2(type) {
      this.loadingAuth[type] = true;
      if (type == 'fb'){
        var provider = new firebase.auth.FacebookAuthProvider();
      } else if (type == 'google') {
        provider = new firebase.auth.GoogleAuthProvider();
      }
      provider.setCustomParameters({
        'display': 'popup'
      });
      provider.languageCode = 'fr_FR';
      const self = this;
      firebase.auth().signInWithPopup(provider).then(function(result) {
          self.loadingAuth[type] = false;

          if (result.additionalUserInfo.isNewUser) {
            self.$store.dispatch('showSignUpMessage');
          }
          if (self.redirect) {
            self.$router.push(self.redirect);
          } else {
            self.$router.push({name:'Home'});
          }

      }).catch((e) => {
        self.step = 1;
        self.loadingAuth[type] = false;

        self.alertText2 = self.$t('firebaseAuthError.'+e.code)
        self.alert2 = true;
      });
    },
    textCGU() {
      return this.cgu ? this.$t('signup.cguOK'):this.$t('signup.cguKO');
    },
    signup() {
      this.loading = true;
      const self = this;
      firebase.auth().createUserWithEmailAndPassword(this.form.email, this.form.password)
      .then((data) => {
        data.user.updateProfile({
        displayName: self.form.nickname
      }).then(function() {
  // Update successful.
  let u = firebase.auth().currentUser;
  self.$store.dispatch("fetchUser", u);
  self.$store.dispatch('showSignUpMessage');
  self.$router.push({name:'Home'});

}).catch(function() {
  // An error happened.
});
        self.loading = false;

      }).catch((e) => {
        self.alertText = self.$t('firebaseAuthError.'+e.code)
        self.alert = true;
        self.loading = false;

      });

    }
  }
}
</script>
